import { useState, useEffect } from "react";
import debug from "@plannel/utils/debug-util";

/*
 * DW 대시보드 데이터 조회 — fetch + loading/error 상태.
 *
 * 페이지마다 `if (!payload) return null` 만 있어서 로딩/에러 구분이 없던 것을 여기서 한 번에 처리한다.
 * stale 응답 가드 포함(파라미터가 빨리 바뀔 때 늦게 온 이전 응답이 최신을 덮지 않도록).
 *
 * @param fetcher (params) => Promise<AxiosResponse>  예: salesStatusService.get
 * @param params  쿼리 파라미터 객체
 * @param deps    재조회 트리거 (기본: params 를 직렬화해 비교)
 * @returns { payload, loading, error }
 */
const useDashboardData = (fetcher, params, deps) => {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const key = deps === undefined ? JSON.stringify(params ?? {}) : JSON.stringify(deps);

  useEffect(() => {
    let alive = true;   // stale 응답 가드
    setLoading(true);
    setError(null);
    fetcher(params)
      .then((response) => {
        if (!alive) return;
        setPayload(response?.data ?? null);
      })
      .catch((e) => {
        if (!alive) return;
        debug(e);
        setError(e);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { payload, loading, error };
};

export default useDashboardData;
